import {initWebComponent} from "@/helpers/web-component-helper";
import {addLayer} from "@/helpers/ol/ol-layer-helper";

const template = document.createElement('template');
template.innerHTML = `<label class="switcher mr-2 ml-2">
    <input type="checkbox" class="switcher-input" style="display:none;" checked="checked" id="chbLayerActivePand">
    <span class="switcher-indicator">
      <span class="switcher-yes"></span>
      <span class="switcher-no"></span>
    </span>
    <span class="switcher-label"></span>
</label>`;

export class LayerMenuActiveItemSwitcherComponent extends HTMLElement{
    constructor(){
        super();
        initWebComponent(this, template)

        const id = this.getAttribute('data-id')

        this.addEventListener('change', () => {
            addLayer(id)
        })
    }
}
